import React from "react";
import Carousel from "react-bootstrap/Carousel";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "../../assets/css/Carousel.css";

const CarouselHome = () => {
  return (
    <section className="carousel-section bg-secondary">
      <Container fluid className="carousel-container">
        <Row className="justify-content-center">
          <Col xs={12}>
            <Carousel
              className="custom-carousel"
              interval={3000} // Autoplay interval in milliseconds (3000ms = 3 seconds)
              indicators
              fade // Use 'fade' for transition effect
              pause={false} // Disable pause on hover
              controls={false} // Hide default controls (optional)
              wrap // Wrap around when reaching the last slide
            >
              <Carousel.Item>
                <Row className="justify-content-center my-3 py-5">
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/7IiTTgloJzvGI1TAYymCfbfl3vT.jpg"
                      alt="Parasit"
                    />
                    <br />
                    <h4>
                      <b>Parasit</b>
                    </h4>
                    <h5>Drama</h5>
                  </Col>
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/4YJNp1cquIkX8JxFwkKNEFQ9tgr.jpg"
                      alt="Just Mercy"
                    />
                    <br />
                    <h4>
                      <b>Just Mercy</b>
                    </h4>
                    <h5>Action, Thriller</h5>
                  </Col>
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/qfQ78ZKiouoM2yhAnfNblp9ijQE.jpg"
                      alt="The Hunt"
                    />
                    <br />
                    <h4>
                      <b>The Hunt</b>
                    </h4>
                    <h5>Thriller</h5>
                  </Col>
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/pBbwUKjxOfIsAChBzKsC3a6Zdfm.jpg"
                      alt="The Secret Garden"
                    />
                    <br />
                    <h4>
                      <b>The Secret Garden</b>
                    </h4>
                    <h5>Adventure, Thriller</h5>
                  </Col>
                  {/* Add more columns for additional items */}
                </Row>
              </Carousel.Item>
              {/* Add more Carousel.Items for additional slides */}
              <Carousel.Item>
                <Row className="justify-content-center my-3 py-5">
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/7IiTTgloJzvGI1TAYymCfbfl3vT.jpg"
                      alt="Parasit"
                    />
                    <br />
                    <h4>
                      <b>Parasit</b>
                    </h4>
                    <h5>Drama</h5>
                  </Col>
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/4YJNp1cquIkX8JxFwkKNEFQ9tgr.jpg"
                      alt="Just Mercy"
                    />
                    <br />
                    <h4>
                      <b>Just Mercy</b>
                    </h4>
                    <h5>Action, Thriller</h5>
                  </Col>
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/pBbwUKjxOfIsAChBzKsC3a6Zdfm.jpg"
                      alt="The Hunt"
                    />
                    <br />
                    <h4>
                      <b>The Hunt</b>
                    </h4>
                    <h5>Thriller</h5>
                  </Col>
                  <Col md={3} className="text-left text-light mb-5">
                    <img
                      className="d-block w-100"
                      src="https://image.tmdb.org/t/p/w220_and_h330_face/qfQ78ZKiouoM2yhAnfNblp9ijQE.jpg"
                      alt="The Secret Garden"
                    />
                    <br />
                    <h4>
                      <b>The Secret Garden</b>
                    </h4>
                    <h5>Adventure, Thriller</h5>
                  </Col>
                  {/* Add more columns for additional items */}
                </Row>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CarouselHome;
